// <s-countdown> ticks the server-rendered clock down to data-target (epoch ms) and reveals the live message at zero.
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.target = Number(this.dataset.target);
    this.clock = this.querySelector('[data-countdown-clock]');
    this.done = this.querySelector('[data-countdown-done]');
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    if (!Number.isFinite(this.target)) return;
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
    const values = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };
    for (const [unit, el] of Object.entries(this.units)) {
      if (el) el.textContent = String(values[unit]).padStart(2, '0');
    }
    if (remaining === 0) {
      clearInterval(this.#timer);
      this.clock?.setAttribute('hidden', '');
      this.clock?.classList.add('hidden');
      this.done?.removeAttribute('hidden');
      this.done?.classList.remove('hidden');
    }
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
